import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-label-popup',
  template: `
    <div class="label-context-menu">
      <strong>{{ label }}</strong>
      <hr />
      <p-button matTooltip="Edit Label"
                class="action-button p-1" icon="pi pi-pencil" (onClick)="edit.emit()"></p-button>
      <p-button matTooltip="Delete Label" icon="pi pi-trash" severity="danger" (onClick)="delete.emit()" />
    </div>
  `
})
export class LabelPopupComponent {
  @Input() label!: string;
  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
}
